import { AnimatedCircularProgressBar } from '@talentmesh/ui/components/animated-circular-progress-bar';
import { PercentileLevel } from '@talentmesh/utils';

import ConnectorIcon from './ConnectorIcon';
import isFlipped from './PetalUtils';

export interface LeftPetalProps {
    value: number;
    level: PercentileLevel;
    name: string;
    index: number;
    count: number;
}
function LeftPetal({ value, level, name, index, count }: LeftPetalProps) {
    return (
        <div className="grid w-full grid-cols-12 items-center">
            <div className="col-span-6">
                <h5 className="text-right text-base font-semibold">{name}</h5>
            </div>
            <div className="col-span-3 mx-auto">
                <AnimatedCircularProgressBar value={value} level={level} className="size-12 text-base font-semibold" />
            </div>
            <div className="col-span-3">
                <ConnectorIcon index={index} count={count} isFlipped={isFlipped(count, index)} />
            </div>
        </div>
    );
}

export default LeftPetal;
